/** `/api/v1` from the browser: the session cookie is the principal, the workspace is explicit. */
export async function apiCall<T>(
  workspaceId: string,
  method: string,
  path: string,
  body?: unknown,
): Promise<T> {
  const sep = path.includes("?") ? "&" : "?";
  const res = await fetch(`/api/v1${path}${sep}workspace=${encodeURIComponent(workspaceId)}`, {
    method,
    credentials: "same-origin",
    headers: body === undefined ? {} : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = (await res.json()) as T & { error?: string };
  if (!res.ok) throw new Error(data.error ?? "error.generic");
  return data;
}
